import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import { useSeo } from "@/hooks/useSeo";
import { siteBrand } from "@/mocks/site";
import HeroSection from "./components/HeroSection";
import StatsStrip from "./components/StatsStrip";
import LeadTypesSection from "./components/LeadTypesSection";
import ProcessSection from "./components/ProcessSection";
import SecuritySection from "./components/SecuritySection";
import VerifySection from "./components/VerifySection";
import TrustSection from "./components/TrustSection";
import FaqPreviewSection from "./components/FaqPreviewSection";
import CtaBand from "./components/CtaBand";

const homeSchema = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteBrand.fullName,
    url: "https://hongshanyang.cn/",
    description:
      "面向知情者与内部人士的独家爆料线索征集平台，开放匿名投稿与私信通道，接收原始素材与文件并负责核实与呈现。",
    inLanguage: "zh-CN",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteBrand.name,
    url: "https://hongshanyang.cn/",
    description: "独立核实小组运营的线索征集中心，不隶属于任何商业机构。",
    email: siteBrand.email,
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "线索征集",
      email: siteBrand.email,
      availableLanguage: ["zh-CN"],
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "暗线 · 独家爆料线索征集中心｜匿名爆料投稿与私信通道",
    url: "https://hongshanyang.cn/",
    description:
      "独家爆料投稿与私信通道开放，面向知情者征集线索与材料，提供匿名保护、交叉核验与脱敏处理。",
    inLanguage: "zh-CN",
  },
];

export default function Home() {
  useSeo({
    title: "暗线 · 独家爆料线索征集中心｜匿名爆料投稿与私信通道",
    description:
      "暗线是面向知情者的独家爆料线索征集中心，开放匿名爆料投稿与私信通道。你提供原始素材与文件，我们负责核实与呈现，全程匿名保护，让每一条线索都被认真对待。",
    keywords: "独家爆料,独家爆料投稿,独家爆料私信,独家爆料线索,独家爆料征集",
    path: "/",
    schema: homeSchema,
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <HeroSection />
        <StatsStrip />
        <LeadTypesSection />
        <ProcessSection />
        <SecuritySection />
        <VerifySection />
        <TrustSection />
        <FaqPreviewSection />
        <CtaBand />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}